/* eslint-disable @typescript-eslint/no-redeclare */
import { CommunityInvite } from '../models/inviteService.model';
import { CommunityFeatures, SubscriptionType } from './misc';

export type Subscription = {
  subscriptionId: string;
  productId: string;
  active: boolean;
  willRenew: boolean;
  type: SubscriptionType;
};

export type MemberDashboard = {
  dashboardId: number;
};

export default interface Community {
  id: number;
  role: CommunityRole;
  inviteId: string | null;
  picture: string | null;
  name: string;
  description: string;
  type: CommunityType;
  inviteFields?: CommunityInvite;
  deprecated_communityId?: number;
  subscription?: Subscription;
  trialType?: SubscriptionType;
  trialEndDate?: string | Date;
  dashboard?: MemberDashboard;
  features?: CommunityFeatures;
  memberPermissions?: CommunityMemberPermissions;
}

export enum CommunityType {
  ROOMMATES = 'ROOMMATES',
  STUDENTGROUP = 'STUDENTGROUP',
  SPORTTEAM = 'SPORTTEAM',
  ASSOCIATION = 'ASSOCIATION',
  COLLEAGUES = 'COLLEAGUES',
  FAMILY = 'FAMILY',
  FRIENDS = 'FRIENDS',
  OTHER_COMMUNITY = 'OTHER_COMMUNITY',
}

export enum CommunityRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export interface Admin {
  adminId?: number;
  userId?: number;
  role: CommunityRole;
  display: string;
  picture?: string;
  pending?: boolean;
  inviteId?: number;
  onboarding?: boolean;
}

/**
 * Model AdminInvite
 *
 */
export type AdminInvite = {
  inviteId: number;
  userId?: number;
  display: string;
  picture?: string;
  role: CommunityRole;
};

export type CommunityMemberPermissions = {
  [CATEGORY in 'EVENTS' | 'MEMBERS' | 'STATS_AND_SCORES' | 'TASKS' | 'PHOTO_ALBUMS' | 'COST_SPLITTING']?: {
    [OPERATION in 'CREATE' | 'UPDATE' | 'DELETE']?: boolean;
  };
};
